import { render, staticRenderFns } from "./Resources.vue?vue&type=template&id=34133e0e&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"
import style0 from "./Resources.vue?vue&type=style&index=0&id=34133e0e&prod&scoped=true&lang=css"
import style1 from "./Resources.vue?vue&type=style&index=1&id=34133e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34133e0e",
  null
  
)

export default component.exports